import React, { useEffect } from "react";
import Adminlayout from "../Adminlayout";
import StudentDetails from "../../components/studentPortal/Components/StudentDetails";
import { useDispatch, useSelector } from "react-redux";
import authService from "../../services/auth.service";
import ChalanStatus from "../../components/studentPortal/Components/ChalanStatus";

const Chalan = () => {
  const studentInformation = useSelector((state) => state.auth.studentData);

  const dispatch = useDispatch();

  useEffect(() => {
    authService.getUser(dispatch);
  }, []);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  return (
    <Adminlayout>
     

       
          <ChalanStatus student={studentInformation} formatDate={formatDate} />
      
   
    </Adminlayout>
  );
};

export default Chalan;
